let breadCrumbElm = document.querySelector('.breadcrumb');

if (breadCrumbElm != null) {
    let breadCrumbContainer = breadCrumbElm.closest('.grid-container-small');
    if (breadCrumbContainer != null) {
        breadCrumbContainer.classList.remove('grid-container-small');
        breadCrumbContainer.classList.add('grid-desktop-large');
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const coveoTilesContainer = document.querySelector('.plpGridList');
    catalogueFlyerGrid.init();
    _bindSuggestionAnonymEvents();

    if (!isInWebview()) {
        triggerCouponViewAfterReload();
    }

    if (coveoTilesContainer !== null) {
        catalogueFlyerGrid.positionMarketingTiles();
    }

    //ON RESIZE IF DIFFERENT BREAKPOINT DISPLACE TILES
    let currentTilesPerRow = catalogueFlyerGrid.setTilesPerRowValue();
    $(window).on('resize', _.debounce(function () {
        if (currentTilesPerRow !== catalogueFlyerGrid.setTilesPerRowValue()) {
            if (coveoTilesContainer !== null) {
                catalogueFlyerGrid.positionMarketingTiles();
            }
            currentTilesPerRow = catalogueFlyerGrid.setTilesPerRowValue();
        }
    }, 1000));
});

function triggerCouponViewAfterReload() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('sectionSelected') === 'coupon') {
        const couponFilterBtn = document.getElementById('showCouponsZone');
        couponFilterBtn?.click();
    }
}

const _bindSuggestionAnonymEvents = function () {
    $(document).on('click', '.suggestions.sign-in', function () {
        _push_custom_event_to_GA4('login_intent', 'origin', 'my suggestions');
    });

    $(document).on('click', '.suggestions.create.account', function () {
        _push_custom_event_to_GA4('sign_up_intent', 'origin', 'my suggestions');
    });
};

const catalogueFlyerGrid = function () {
    const plpDesktopBreakpoint = 1200;
    const plpDesktopOnekBreakpoint = 1900;
    const plpDesktopTwokBreakpoint = 2140;
    let screenWidth = window.innerWidth;

    const _setTilesPerRowValue = function () {
        screenWidth = window.innerWidth;
        if (screenWidth < plpDesktopBreakpoint) {
            return 6;
        }
        if (screenWidth >= plpDesktopBreakpoint && screenWidth < plpDesktopOnekBreakpoint) {
            return 5;
        }
        if (screenWidth >= plpDesktopOnekBreakpoint && screenWidth < plpDesktopTwokBreakpoint) {
            return 7;
        }
        if (screenWidth >= plpDesktopTwokBreakpoint) {
            return 8;
        }
    };

    const _sfySignInOrSignUp = function(event) {
        if (isInWebview() && !isAuthenticated) {
            sendUserNotAuthenticatedEventToDevice();
        } else {
            submitLoginSignupForm(event);
        }
    };

    const _init = function () {
        const gridFlyerPageFilters = document.querySelectorAll('.flyerGridFilters > *');
        const gridFlyerPageFiltersBtn = document.querySelectorAll('.flyerGridFilters > button');
        const couponFilterBtn = document.getElementById('showCouponsZone');
        const gridTileContainer = document.querySelector('.product-page-filter');
        const suggestionForYouContainer = document.querySelector('.info-just-for-you');
        let totalFlyerFilterWidth = 42;
        let screenWidth = window.innerWidth;

        let activeSlide;
        let $slider = $('.view-mode-toggle.flyerGridFilters');
        _initFlyerGridFiltersTracking();
        gridFlyerPageFilters.forEach(filterItem => {
            totalFlyerFilterWidth += filterItem.offsetWidth;
        });

        if (!isInWebview()) {
            gridFlyerPageFiltersBtn.forEach(filterItem => {
                filterItem.addEventListener('click', function (event) {
                    gridFlyerPageFilters.forEach(element => {
                        element.classList.remove('active');
                    });
                    event.target.classList.add('active');

                    if ($slider.hasClass('slick-initialized')) {
                        activeSlide = $slider.find('.slick-slide.active').data('slick-index');
                        $slider.slick("slickGoTo", activeSlide);
                    }

                    const isCoupon = event.target === couponFilterBtn;
                    if (isCoupon) {
                        _setViewCouponSection('coupon');
                        gridTileContainer.classList.add('hide-section');
                        if (suggestionForYouContainer) {
                            suggestionForYouContainer.classList.add('hide-section');
                        }
                    }
                    _setViewCouponSection(isCoupon ? 'coupon' : null);

                    if (event.target.classList.contains('toggle-gridTiles')) {
                        gridTileContainer.classList.remove('hide-section');
                        if (suggestionForYouContainer) {
                            suggestionForYouContainer.classList.remove('hide-section');
                        }
                    }
                });
            });
        }

        if (totalFlyerFilterWidth >= screenWidth) {
            flyerGridFilters();
        }

        let hasUsedGenius = localStorage.getItem("hasUsedGenius") === 'true';
        if (!hasUsedGenius) {
            $('.plpGridList').addClass('has-tooltip-tile');
        }

        initPlpCarrousel();

        const enrollMoiProgram = document.querySelector('.banner-login-coupons.banner-login-not-member .banner-button');
        if(enrollMoiProgram) {
            enrollMoiProgram.addEventListener('click', function (event) {
                _push_custom_event_to_GA4('moi_enroll_click', 'description', 'bottom banner');
            });
        }

        scrollToAnchor();
    };

    const _positionMarketingTiles = function () {

        const injectObjectArrayToRow = function (row, objArray, adjustTo) {
            let tileIndex = ((itemsPerRow * row) + adjustTo) - injectedTiles;
            if (typeof coveoTiles[tileIndex] !== 'undefined') {
                coveoTiles[tileIndex].before(...objArray);
            }
        }

        let injectedTiles = 0;
        let itemsPerRow = catalogueFlyerGrid.setTilesPerRowValue();
        const coveoTilesContainer = document.querySelector('.plpGridList');
        const coveoTiles = document.querySelectorAll('.plpGridList .plp-tile');
        const hasButterFlyTile = document.getElementsByClassName('has-butterfly-tile').length;
        const sponsoredTile = document.querySelectorAll('.sponsoredTile');

        const cartGeniusTile = document.querySelectorAll('.has-genius-tile');
        const cartGeniusTileTip = document.querySelectorAll('.has-tooltip-tile');

        const uPassTile = document.querySelectorAll('.upass-tile');
        const cartGeniusContainer = document.querySelector('#cartGeniusPlaceholder');
        let flyerAddA = document.querySelector('.flyerPromo-a');
        let flyerAddB = document.querySelector('.flyerPromo-b');

        if (flyerAddA !== null) {
            if (flyerAddA.textContent.trim().length === 0) {
                flyerAddA.remove();
                flyerAddA = false;
            }
        }

        if (flyerAddB !== null) {
            if (flyerAddB.textContent.trim().length === 0) {
                flyerAddB.remove();
                flyerAddB = false;
            }
        }

        if (typeof coveoTilesContainer === 'undefined') {
            return;
        }

        let row1TilesToPush = [];
        let row2TilesToPush = [];
        let row3TilesToPush = [];
        let row4TilesToPush = [];
        let row5TilesToPush = [];
        let row6TilesToPush = [];

        // CONDITIONS FOR ROW 1
        if (hasButterFlyTile) {
            if (screenWidth < plpDesktopBreakpoint) {
                injectedTiles = injectedTiles + 1;
            } else {
                injectedTiles = injectedTiles + 2;
            }
        }

        if (cartGeniusTile.length && cartGeniusTileTip.length) {
            injectedTiles = injectedTiles + 3;
            row1TilesToPush.push(cartGeniusContainer);
        }
        if (cartGeniusTile.length && !cartGeniusTileTip.length) {
            injectedTiles = injectedTiles + 2;
            row1TilesToPush.push(cartGeniusContainer);
        }
        if (sponsoredTile.length) {
            injectedTiles = injectedTiles + 1;
        }
        if (injectedTiles <= itemsPerRow) {
            if (sponsoredTile.length) {
                row1TilesToPush.unshift(sponsoredTile[0]);
            }
            injectObjectArrayToRow(1, row1TilesToPush, 0);
        } else {
            if (sponsoredTile.length) {
                row2TilesToPush.push(sponsoredTile[0]);
            }
            coveoTiles[0].before(...row1TilesToPush);
        }

        // CONDITIONS FOR ROW 2
        if (sponsoredTile.length > 1 && row2TilesToPush.length > 0) {
            row3TilesToPush.push(sponsoredTile[1]);
        } else if (sponsoredTile.length > 1 && row2TilesToPush.length === 0) {
            row2TilesToPush.push(sponsoredTile[1]);
            injectedTiles = injectedTiles + 1;
        }
        if (uPassTile.length) {
            row2TilesToPush.push(uPassTile[0]);
            injectedTiles = injectedTiles + 2;
        }
        injectObjectArrayToRow(2, row2TilesToPush, 0);

        // CONDITIONS FOR ROW 3
        if (sponsoredTile.length > 2 && row3TilesToPush.length > 0) {
            row4TilesToPush.push(sponsoredTile[2]);
            injectedTiles = injectedTiles + 1;
        } else if (sponsoredTile.length > 2 && row3TilesToPush.length === 0) {
            row3TilesToPush.push(sponsoredTile[2]);
            injectedTiles = injectedTiles + 1;
        }
        if (flyerAddA) {
            injectedTiles = injectedTiles + 1;
            let flyerPlaceHolderIndexA = ((itemsPerRow * 2) + 3 - injectedTiles);
            let flyerPlaceHolderA = coveoTiles[flyerPlaceHolderIndexA];
            if (flyerPlaceHolderA) {
                flyerPlaceHolderA.before(flyerAddA);
            }
        }
        injectObjectArrayToRow(3, row3TilesToPush, 0);

        // CONDITIONS FOR ROW 4
        if (sponsoredTile.length > 3 && row4TilesToPush.length > 0) {
            row5TilesToPush.push(sponsoredTile[3]);
            injectedTiles = injectedTiles + 1;
        } else if (sponsoredTile.length > 3 && row4TilesToPush.length === 0) {
            row4TilesToPush.push(sponsoredTile[3]);
            injectedTiles = injectedTiles + 1;
        }
        if (flyerAddB) {
            injectedTiles = injectedTiles + 1;

            let flyerPlaceHolderIndexB = ((itemsPerRow * 4) - 1 - injectedTiles);
            let flyerPlaceHolderB = coveoTiles[flyerPlaceHolderIndexB];
            if (flyerPlaceHolderB) {
                flyerPlaceHolderB.before(flyerAddB);
            }
        }
        injectObjectArrayToRow(4, row4TilesToPush, 0);

        // CONDITIONS FOR ROW 5
        if (sponsoredTile.length > 4 && row5TilesToPush.length > 0) {
            row6TilesToPush.push(sponsoredTile[4]);
            injectedTiles = injectedTiles + 1;
        } else if (sponsoredTile.length > 4 && row5TilesToPush.length === 0) {
            row5TilesToPush.push(sponsoredTile[4]);
            injectedTiles = injectedTiles + 1;
        }
        injectObjectArrayToRow(5, row5TilesToPush, 0);

        // CONDITIONS FOR ROW 6
        if (row6TilesToPush.length > 0) {
            injectedTiles = injectedTiles + 1;
        }
        injectObjectArrayToRow(6, row6TilesToPush, 0);


        coveoTilesContainer.classList.remove('in-progress');
    };

    const _initFlyerGridFiltersTracking = function () {
        document.addEventListener('click', function (event) {
            const target = event.target.closest('.suggestions-foryou, .complete-flyer, .showCoupons');

            if (!target) {
                return;
            }
            _pushDataLayerFlyerGridFilters(target);
        });
    };

    const scrollToAnchor = function () {
        const hash = window.location.hash;
        if (!hash) return;

        // on va scroller juste pour ce cas
        if (hash === '#filterAnchor') {
            const target = document.querySelector(hash);
            if (!target) return;

            const y = target.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: y,
                behavior: "auto"
            });
        }
    };

    const _pushDataLayerFlyerGridFilters = function (element) {
        if ($(element).hasClass('complete-flyer')) {
            _push_custom_event_to_GA4('tab_click', 'description', 'Complete Flyer');
        } else if ($(element).hasClass('suggestions-foryou')) {
            _push_custom_event_to_GA4('tab_click', 'description', 'My Suggestions');
        } else if ($(element).hasClass('showCoupons')) {
            _push_custom_event_to_GA4('tab_click', 'description', 'My Coupons');
        }
    };

    const _setViewCouponSection = function (coupon) {
        const url = new URL(window.location.href);
        if (coupon) {
            url.searchParams.set('sectionSelected', coupon);
        } else {
            url.searchParams.delete('sectionSelected');
        }
        history.replaceState(null, '', url.toString());
    };

    return {
        init: _init,
        setTilesPerRowValue: _setTilesPerRowValue,
        positionMarketingTiles: _positionMarketingTiles,
        sfySignInOrSignUp: _sfySignInOrSignUp,
    }
}();